import { useMemo } from 'react'
import { APPLICATION_CLUSTERS_QUERY } from '@/components/form/location-selector/query'
import { useIdCompany, useSuspenseQuery } from '@/lib/hooks'
import type {
  ApplicationClustersQuery,
  ApplicationClustersQueryVariables,
} from '@/components/form/location-selector/query.types.gen'

export const useClusters = () => {
  const { idCompany } = useIdCompany()

  const { data } = useSuspenseQuery<
    ApplicationClustersQuery,
    ApplicationClustersQueryVariables
  >(APPLICATION_CLUSTERS_QUERY, { variables: { idCompany } })

  const clusters = useMemo(() => data?.company?.clusters ?? [], [data])
  const recentClusters = useMemo(
    () => data?.company?.recentClusters ?? [],
    [data]
  )

  return { clusters, recentClusters }
}
